import di from "../../../dependency_injection";
import KeyWordLocalization from "../../../presentation/utils/KeyWordLocalization";
import LocalizationProvider, { LocalizationProviderName } from "../../providers/localization/LocalizationProvider";
import ModalsProvider from "../../providers/modal/ModalsProvider";
import SettingsRepository from "../../repositories/settings.repository";

interface props {
    settingsRepository: SettingsRepository;
    modalsProvider: ModalsProvider;
    localizationProvider: LocalizationProvider;
}
export default class ChangeThemeUseCase {
    _settingsRepository: SettingsRepository;
    _modalsProvider: ModalsProvider;
    _localizationProvider: LocalizationProvider;

    constructor(_: props) {
        this._settingsRepository = _.settingsRepository;
        this._modalsProvider = _.modalsProvider;
        this._localizationProvider = _.localizationProvider;
    }

    public call = async (theme: string): Promise<void> => {
        this._settingsRepository.setCurrentTheme(theme);
        const themeTranslate = this._localizationProvider.Actions.i18n(theme);
        const text = this._localizationProvider.Actions.i18n(KeyWordLocalization.ChangeThemeUseCaseThemeChangedTo, { theme: themeTranslate });
        this._modalsProvider.Actions.addToast(text, "success", {});

    }
}

export const ChangeThemeUseCaseName = "ChangeThemeUseCase";